import { Navigate, useLocation, useParams } from 'react-router-dom';
import { ROUTES } from '../routes.js';

export type LegacyRedirectKind = 'planNew' | 'planEdit' | 'scenarioNew' | 'scenarioEdit';

/** M-143 以前の URL を新しい URL に読み替える（純関数 / query はそのまま引き継ぐ）。 */
export function resolveLegacyPath(
  kind: LegacyRedirectKind,
  params: { planId?: string; scenarioId?: string },
  search: string,
): string {
  const query = new URLSearchParams(search);
  const withQuery = (path: string): string => {
    const [base, own] = path.split('?');
    const merged = new URLSearchParams(own ?? '');
    query.forEach((value, key) => {
      if (!merged.has(key)) merged.set(key, value);
    });
    const text = merged.toString();
    return text ? `${base}?${text}` : (base ?? path);
  };
  switch (kind) {
    case 'planNew':
      return withQuery(ROUTES.kpiPlanNew);
    case 'planEdit':
      return withQuery(params.planId ? ROUTES.kpiPlanEdit(params.planId) : ROUTES.kpi);
    case 'scenarioNew':
      return withQuery(params.planId ? ROUTES.scenarioNew(params.planId) : ROUTES.kpi);
    case 'scenarioEdit':
      return withQuery(
        params.scenarioId ? ROUTES.scenarioEdit(params.scenarioId) : ROUTES.kpi,
      );
  }
}

/**
 * M-143: `/plans` を配信ツリーに明け渡したので、旧 URL（`/plans/new` `/plans/:planId`
 * `/plans/:planId/scenarios/...`）を `/kpi/...` `/scenarios/...` へ送る。
 * ブックマークと、他画面に残った古いリンクの受け皿。
 */
export function LegacyRedirect({ kind }: { kind: LegacyRedirectKind }) {
  const params = useParams<{ planId?: string; scenarioId?: string }>();
  const location = useLocation();
  return <Navigate to={resolveLegacyPath(kind, params, location.search)} replace />;
}
